








































import Vue from 'vue';

export default Vue.extend({
  name: 'TreeViewHeader',
  props: {
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: false
    },
    showRefresh: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onExpandOrCollapseClicked(this: any, event: string) {
      this.$emit(event);
    },
    onRefreshClicked(this: any) {
      this.$emit('treeview-header-refresh-clicked');
    }
  }
});
